import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faBook, faCalendar, faUser } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import { db } from "../config/firebase";
import { collection, addDoc } from "firebase/firestore";

const CourseInformation = ({ course }) => {
  const navigate = useNavigate();
  const { courseid } = useParams();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [comment, setComment] = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const toggleModal = () => {
    if (showModal) {
      // Reset all input fields when closing the modal
      setFirstName('');
      setLastName('');
      setEmail('');
      setPhoneNumber('');
      setBirthdate('');
      setComment('');
      setIsSent(false); // Reset the "thank you" message visibility
    }
    setShowModal(!showModal);
  };
  
  const formatLearnText = (text) => {
    const points = text.split("--").filter((point) => point.trim() !== "");
    return points.map((point, index) => {
      const [boldText, description] = point.split(":");
      return (
        <li key={index}>
          <strong>{boldText.trim()}:</strong> {description.trim()}
        </li>
      );
    });
  };

  const formatActivitiesText = (text) => {
    const points = text.split("--").filter((point) => point.trim() !== "");
    return points.map((point, index) => <li key={index}>{point.trim()}</li>);
  };

  const addContact = async (e) => {
    e.preventDefault();
    if (!email || !firstName || !lastName || !comment) {
      alert("Please fill in all fields.");
      return;
    }

    try {
      const newQuery = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        comment: comment,
        phoneNumber: phoneNumber,
        birthdate: birthdate,
        date : Date.now(),
      };
      await addDoc(collection(db, "enquiry"), newQuery); // Fixed: "enquiry" should be a string

      setFirstName('');
      setEmail('');
      setLastName('');
      setComment('');
      setPhoneNumber('');
      setBirthdate('');
      setShowModal(false);
      setIsSent(true);
    } catch (error) {
      console.error("Error submitting enquiry:", error);
      alert("Failed to add enquiry.");
    }
  };

  return (
    <div className="course-content">
      <div className="description-section">
        <p className="course-description">{course.information}</p>
      </div>

      <div className="what-you-will-learn">
        <h2>What You Will Learn</h2>
        <ul>{formatLearnText(course.learn)}</ul>
      </div>

      <div className="activities">
        <h2>Activities</h2>
        <ul>{formatActivitiesText(course.activities)}</ul>
      </div>

      <div className="what-to-expect">
        <h2>What to Expect</h2>
        <ul>
          <li>
            <FontAwesomeIcon icon={faClock} className="icon" />
            <span>
              Enjoy the flexibility of choosing 2 out of 5 available days each week to attend your
              classes. This allows you to balance your learning with other commitments easily.
            </span>
          </li>
          <li>
            <FontAwesomeIcon icon={faBook} className="icon" />
            <span>
              Receive comprehensive worksheets and take regular tests designed to reinforce your
              learning and track your progress throughout the course.
            </span>
          </li>
          <li>
            <FontAwesomeIcon icon={faCalendar} className="icon" />
            <span>
              Engage in a structured 20-weeks program with 2 classes per week. This schedule ensures
              steady progress and adequate time for absorption and practice of the material.
            </span>
          </li>
          <li>
            <FontAwesomeIcon icon={faUser} className="icon" />
            <span>
              Gain access to a supportive community of learners at a similar level. This network
              provides opportunities for collaboration, discussion, and mutual encouragement.
            </span>
          </li>
        </ul>
      </div>

      <div className="course-details">
        <div className="details-content">
          <button
            className="enroll-button"
            onClick={toggleModal}
          >
            Enquire Now
          </button>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="custom-close-button" onClick={toggleModal}>X</button>
            <h3>Send Course enquiry and we will get back to you</h3>
            <form onSubmit={addContact} className="add-student-form">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                id="firstName"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
              />
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                id="lastName"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
<label htmlFor="email">Email</label>
<input
  type="email"  // HTML5 email validation
  id="email"
  value={email}
  onChange={(e) => setEmail(e.target.value)}
  placeholder="Enter your email address"
  required
  onInvalid={(e) => e.target.setCustomValidity('Please enter a valid email address')}
  onInput={(e) => e.target.setCustomValidity('')} // Clear custom message when input changes
/>

<label htmlFor="phoneNumber">Phone Number</label>
<input
  type="tel"  // Use 'tel' for better UX
  id="phoneNumber"
  value={phoneNumber}
  onChange={(e) => setPhoneNumber(e.target.value)}
  placeholder="Enter your phone number"
  pattern="[0-9]{10}"  // Example: 10 digits for standard phone numbers
  title="Phone number should be 10 digits."
/>

<label 
    htmlFor="birthdate" 
    className={`date-label ${birthdate ? "filled" : ""}`}
  >
    {birthdate ? "Selected Birthdate" : "Select your birthdate"}
  </label>
  <input
    type="date"
    id="birthdate"
    value={birthdate}
    onChange={(e) => setBirthdate(e.target.value)}
    className="date-input"
  />


              <label htmlFor="comment">Comment</label>
              <textarea
                id="comment"
                className="custom-textarea"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                required
              />
              <button type="submit" className="primary-button">
                Send
              </button>
            </form>
            {isSent && (
              <div className="thank-you-message">
                <h2>Thank you for your enquiry!</h2>
                <p>We will get back to you as soon as possible.</p>
              </div>
            )}
          </div>
        </div>
      )}

<style jsx>{`
  .course-content {
    display: flex;
    flex-direction: column;
    gap: 40px;
    margin-top: 60px;
    max-width: 1200px;
    padding: 20px;
    margin: 0 auto;
    margin-bottom: 60px;
  }

  .description-section {
    padding-left: 20px;
    padding-right: 20px;
  }

  .course-description {
    font-size: 1.3rem;
    color: #7f8c8d;
    line-height: 1.6;
  }

  .what-to-expect {
    padding: 20px;
    border-radius: 8px;
  }

  .what-to-expect h2 {
    font-size: 1.8rem;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 15px;
  }

  .what-to-expect ul {
    list-style: none;
    padding: 0;
  }

  .what-to-expect li {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 1.2rem;
    color: #34495e;
    border-left: 4px solid #6a5acd;
    padding-left: 15px;
    transition: transform 0.3s ease, background-color 0.3s ease;
  }

  .what-to-expect li:hover {
    transform: scale(1.02);
    background-color: #eef1f7;
  }

  .what-to-expect .icon {
    font-size: 1.8rem;
    margin-right: 10px;
    color: #6a5acd;
  }

  .what-you-will-learn,
  .activities {
    padding-left: 20px;
    padding-right: 20px;
  }

  .what-you-will-learn h2,
  .activities h2 {
    font-size: 1.8rem;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 15px;
  }

  .what-you-will-learn ul,
  .activities ul {
    list-style: none;
    padding: 0;
  }

  .what-you-will-learn li,
  .activities li {
    font-size: 1.2rem;
    color: #34495e;
    margin-bottom: 10px;
  }

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background-color: white;
    padding: 30px;
    border-radius: 8px;
    position: relative;
    width: 600px;
    max-width: 80%;
    max-height: 80%;
    overflow-y: auto;
  }

  .custom-close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 1.5rem;
    background: #6a5acd;
    border: none;
    cursor: pointer;

  }

  .add-student-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .add-student-form label {
    font-size: 1.1rem;
    color: #2c3e50;
  }

  .add-student-form input,
  .add-student-form textarea {
    padding: 10px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 100%;
    background: none;  /* Remove background lines */
    outline: none; /* Remove focus outline */
  }

  .add-student-form textarea {
    background: none;  /* Specifically target the textarea */
    border: 1px solid #ccc; /* Set border style */
  }

  .primary-button {
    background-color: #6a5acd;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1.2rem;
  }

  .primary-button:hover {
    background-color: #4b3f8f;
  }

  .thank-you-message {
    text-align: center;
    margin-top: 20px;
  }

  .thank-you-message h2 {
    color: #2c3e50;
  }
`}</style>


    </div>
  );
};

export default CourseInformation;
